import React from "react";
import nextId from "react-id-generator";
import { getAllFAQ } from "../../APIs/GetAPIs";
import { Images } from "../../Assets/0a-exporter";
import CommonFooter from "../LandingPage/CommonFooter/CommonFooter";
import LandingHeader from "../LandingPage/LandingHeader/LandingHeader";
import "./help-page.style.scss";
export default function HelpPage() {
  const [opened, setOpened] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  const [qnaList, setQNAList] = React.useState({
    candidate: [],
    institution: [],
  });
  const [loading, setLoading] = React.useState(true);
  const setUpQNAList = async () => {
    setLoading(true);
    let res = await getAllFAQ();
    if (res.data.statusCode === 200) {
      let temp = {
        candidate: [],
        institution: [],
      };
      res.data.data.map((obj) => {
        if (obj.faq_for === "candidate") {
          temp = { ...temp, candidate: [...temp.candidate, obj] };
        } else {
          temp = { ...temp, institution: [...temp.institution, obj] };
        }
      });
      setQNAList({ ...temp });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const handleClick = (obj) => {
    if (opened.includes(obj._id)) {
      let temp = opened.filter((x) => {
        return x !== obj._id;
      });
      setOpened([...temp]);
    } else {
      setOpened([...opened, obj._id]);
    }
  };
  React.useEffect(() => {
    setUpQNAList();
  }, []);

  return (
    <div className="help-page-main">
      <LandingHeader opaque="opaque" help={true} />
      <div className="help-page-title">
        <h2>How can we help?</h2>

        <div className="lcm-options">
          <div
            className={
              selectedOption.id === "candidate" ? "left-most" : "right-most"
            }
          />
          {options.map((obj) => (
            <h6
              onClick={() => setSelectedOption(obj)}
              className={obj.id === selectedOption.id ? "selected" : ""}
              key={obj.keyId}
            >
              {obj.text}
            </h6>
          ))}
        </div>
        <div className="hpm-search-wrapper">
          <span>
            <img src={Images.graySearch} />
          </span>
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type"
          />
          <button>Search</button>
        </div>
      </div>

      <div className="hpm-body">
        <div className="hpm-qa-section">
          <ul>
            {qnaList[selectedOption.id]
              .filter((x) => {
                return (
                  x.answer.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
                  x.question.toLowerCase().startsWith(searchTerm.toLowerCase())
                );
              })
              .map((obj) => (
                <li className={opened.includes(obj._id) ? "open-it" : ""}>
                  <div onClick={() => handleClick(obj)} className="question">
                    <p>{obj.question}</p>{" "}
                    <img
                      className="arrow-down"
                      src="https://img.icons8.com/material-sharp/50/000000/sort-down.png"
                    />
                  </div>
                  <div className="answer">{obj.answer}</div>
                </li>
              ))}
          </ul>
        </div>
        <div className="hpm-qa-footer"></div>
      </div>
      <CommonFooter />
    </div>
  );
}

const options = [
  { keyId: nextId(), id: "candidate", text: "For Candidates" },
  { keyId: nextId(), id: "institution", text: "For Institutes" },
];

const qaList = [
  {
    keyId: nextId(),
    ques: "Which material types can you work with?",
    ans: "Progressively generate synergistic total linkage through cross-media intellectual capital. Enthusiastically parallel task team building e-tailers without standards compliant initiatives.",
  },
  {
    keyId: nextId(),
    ques: "Which material types can you work with?",
    ans: "Progressively generate synergistic total linkage through cross-media intellectual capital. Enthusiastically parallel task team building e-tailers without standards compliant initiatives.",
  },
  {
    keyId: nextId(),
    ques: "Which material types can you work with?",
    ans: "Progressively generate synergistic total linkage through cross-media intellectual capital. Enthusiastically parallel task team building e-tailers without standards compliant initiatives.",
  },
  {
    keyId: nextId(),
    ques: "Which material types can you work with?",
    ans: "Progressively generate synergistic total linkage through cross-media intellectual capital. Enthusiastically parallel task team building e-tailers without standards compliant initiatives.",
  },
  {
    keyId: nextId(),
    ques: "Which material types can you work with?",
    ans: "Progressively generate synergistic total linkage through cross-media intellectual capital. Enthusiastically parallel task team building e-tailers without standards compliant initiatives.",
  },
  {
    keyId: nextId(),
    ques: "Which material types can you work with?",
    ans: "Progressively generate synergistic total linkage through cross-media intellectual capital. Enthusiastically parallel task team building e-tailers without standards compliant initiatives.",
  },
];
